import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { PixHelpComponent } from '../../master/pix/help/help.component';

@Component({
  selector: 'app-modal-antifraud-warning',
  templateUrl: './modal-antifraud-warning.component.html',
  styleUrls: ['./modal-antifraud-warning.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class ModalAntifraudWarningComponent implements OnInit {

	date: string;
	title: string;

  constructor(
		public dialogRef: MatDialogRef<ModalAntifraudWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
		public dialog: MatDialog
  ){
  }

	ngOnInit(): void {
		this.title = this.data && this.data.title ? this.data.title : 'Por segurança, a sua transação está em análise.';
	}

  closeModal(): void {
    this.onClose();
  }

  redirectCallCenter(): void {
		this.openHelpModal();
  }

	public openHelpModal() : void {
		this.onClose();
		this.dialog.open(PixHelpComponent, {
			width: '400px',
		});
	}

	onClose = () => {
		this.router.navigate(['']);
		this.dialogRef.close(true);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/modal-antifraud-warning/modal-antifraud-warning.component.ts